const PublisherModuleDetail = {
    title: 'Devices',
    nav: [
        {
            name: 'Apple Device Registration',
            url: 'apple-device-registration',
            groupsAllowed: ['SECOK-P-BF_publisher_portal_apple_device_registration-User'], // TODO: Create a shared Okta group for RM modules instead of one per module.
        },
    ],
    loadModule: () => import('./bigfishgames-apple-device-registration-portal-module.module-4e608307.mjs').then((m) => m.PortalModule),
};

/*
 * Public API Surface of hello-module
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PublisherModuleDetail };
